<template lang="pug">
.qmodii-modal-content
  VCard
    VCardTitle 
      span.headline Sectors
      VSpacer
      VBtn(icon, @click="close()"): i.material-icons.md-18 close
    VCardText
      div.qmod-sector-tree(focusable)
        VTreeview(:items="options" item-key="code" item-text="name" item-children="group" v-model="tree" selectable, @input="doCall()")
    VCardActions
      VSpacer
      VBtn(color="blue darken-1", flat, @click.native="close") {{ $t('labels.close') }} 
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
  VTreeview,
  VList,
  VSubheader,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VListTileSubTitle,
  VListTileAction,
  VLayout,
  VFlex,
  VTextField,
  VSelect,
  VIcon,
  VBtn,
  VSpacer,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
} from "vuetify/lib";
import ToggleButton from "@LAYOUT/ToggleButton";

export default {
  name: "SectorModal",
  components: {
    VTreeview,
    VList,
    VSubheader,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VListTileAction,
    VLayout,
    VFlex,
    VTextField,
    VSelect,
    VIcon,
    ToggleButton,
    VBtn,
    VSpacer,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
  },
  mounted() {
    this.tree = this.$store.state.MarketScreener.SECTOR_LIST_SELECTED;

    this.options = this.$store.state.MarketScreener.SECTOR_LIST_TREE;

    this.$watch(
      "$i18n.locale",
      async (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
          this.options = this.$store.state.MarketScreener.SECTOR_LIST_TREE;
        // await this.getScreens();
        //
      },
      { immediate: false }
    );
  },
  props: [],
  data() {
    return {
      options: [],
      tree: [],
    };
  },
  watch: {
    async tree (val) {
      this.$store.commit("MarketScreener/SET_SECTOR_LIST_SELECTED", this.tree);
      let sectorupdate = {
        id: 'sectors',
        selected: this.tree
      }

      await this.$store.dispatch("MarketScreener/getFilteredResults");
      await this.$store.dispatch("MarketScreener/getEquityPreviewCount", sectorupdate); //
    }
  },
  methods: {
    async doCall() {
      // this.$store.state.MarketScreener.SECTOR_LIST_SELECTED = this.tree;
      

      // let sectorupdate = {
      //   id: 'sectors',
      //   selected: this.tree
      // }

      // await this.$store.dispatch("MarketScreener/getFilteredResults");
      // await this.$store.dispatch("MarketScreener/getEquityPreviewCount", sectorupdate); //
      // this.$store.commit("MarketScreener/SET_SECTOR_LIST_SELECTED", this.tree);
    },
    async close() {
      this.$emit("finished");
    },
  },
  computed: {
    ...mapGetters("MarketScreener", [
      "gSectorSelected",
    ]),
    getEnabled() {
      return this.isEnabled ? "On" : "Off";
    },
  },
  async created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.qmod-accord-text
  margin-bottom 25px
.qmodii-modal-content
  width 100%
@media (max-width 730px)
  .qmod-sector-tree .v-treeview-node__label
    font-size 11px;
</style>
